module.exports = __webpack_public_path__ + "static/img/banner9.3b3444b1.png";